<template>
  <v-select
    v-if="filter && filter.option.type ==='select'"
    :key="filter.option.key"
    v-model="model"
    :options="filter.option.options"
    :multiple="filter.option.multiple"
    :label="filter.option.label"
    :reduce="option => option[filter.option.key]"
    :placeholder="label"
    dir="rtl"
    @search="fetchOptions"
  />
  <date-picker
    v-else-if="filter && filter.option.type ==='date'"
    :id="filter.query"
    v-model="model"
    type="date"
    :range="filter.option.range"
    editable
    format="YYYY-MM-DD"
    display-format="jYYYY/jMM/jDD"
    color="#28c76f"
    :placeholder="label"
  />
  <date-picker
    v-else-if="filter && filter.option.type ==='datetime'"
    :id="filter.query"
    v-model="model"
    type="datetime"
    :range="filter.option.range"
    editable
    format="YYYY-MM-DD HH:mm"
    display-format="jYYYY/jMM/jDD HH:mm"
    color="#28c76f"
    :placeholder="label"
  />
<!--  <b-form-input-->
<!--    v-else-->
<!--    v-model="model"-->
<!--    :placeholder="label"-->
<!--  />-->

</template>

<script>
import { BFormInput } from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'ListColumnFilter',
  components: {
    vSelect,
    BFormInput,
  },
  props: {
    name: {
      type: String,
      default: () => '',
    },
    label: {
      type: String,
      default: () => '',
    },
    filter: {
      type: Object,
      default: () => {},
    },
    value: {
      type: [String, Array, Number],
      default: () => '',
    },
    form: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      model: '',
      timeout: null,
      timeout2: null,
      debounce: 1,
    }
  },
  watch: {
    model: 'modelChange',
  },
  created() {
    if (this.value !== undefined && this.value !== null) {
      this.model = this.value
      this.getUsers({
        searched: true,
        ids: [this.value],
      })
    }
  },
  methods: {
    modelChange() {
      // clear timeout variable
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => this.$emit('onFilterChange', this.name, this.model), this.debounce * 500)
    },
    /**
       * Triggered when the search text changes.
       *
       * @param search  {String}    Current search text
       * @param loading {Function}	Toggle loading class
       */
    fetchOptions(search, loading = null) {
      if (search && search.length) {
        this.getUsers({ searched: true, search_key: search }, loading)
      }
    },
    getUsers(params, loading = null) {
      clearTimeout(this.timeout2)
      this.timeout2 = setTimeout(() => {
        if (this.name === 'user') {
          if (loading) loading(true)
          this.$http.get('users', { params }).then(({ data }) => {
            this.filter.option.options = data
            if (loading) loading(false)
          })
        }
      }, this.debounce * 500)
    },
  },
}
</script>

<style scoped>

</style>
